<template>
    <div class="col-md-6 col-sm-12 list-content-item borderless p-1">
        <div class="mb-2 bg-white shadow-reg pt-3 pb-3 pr-4 pl-4">
            <h2 class="title mb-2 font-weight-800" v-text="voucher.name"></h2>
            <div class="description">
                <span class="" v-text="displayedDiscount"></span> OFF <span class="" v-text="voucher.product_type"></span>s
            </div>
            <div class="description text-muted mb-2">
                <span class="mr-2">Min. amount spent of</span>
                <span class="" v-text="voucher.min_amount_spent"></span>
            </div>
            <div class="description text-muted" v-text="voucher.description"></div>
        </div>
    </div>
</template>
<script>

export default {
    name: "VoucherListItem",

    computed: {
        displayedDiscount() {
            return this.voucher.displayed_discount.includes("%")
                ? this.voucher.displayed_discount
                : "PHP " + this.voucher.displayed_discount;

            
        }
    },
    
    props: {
        voucher: [Object],
    },

    mounted() {

    }
}
</script>